/**
 * Konfigurační soubor pro admin bundle
 * Definuje, které komponenty se mají načítat v admin.bundle.js
 */

module.exports = {
	// Komponenty, které se mají načítat vždy (core)
	alwaysLoad: {
		Helpers: true,
		ComponentLoader: true,
		FontAwesome: true,
		Naja: true,
		LiveFormValidation: true,
		Toastr: true,
		AfterAjax: true,
	},

	// Komponenty, které se načítají lazy (dynamický import až když jsou potřeba)
	// Format: 'ComponentName': { check: () => boolean }
	// Cesty k importům jsou definovány přímo v ComponentLoader pro správné webpack vyhodnocení
	// TinyMCE se načte jen pokud existuje textarea s data-provide="tinymce" atributem
	lazyLoad: {
		TinyMce: {
			check: () => {
				// Kontrola jak při prvním načtení, tak po AJAX
				return document.querySelector('textarea[data-provide="tinymce"]:not([data-tinymce-init="1"])') !== null;
			},
		},
		// Příklad pro další lazy komponenty:
		// ChartComponent: {
		// 	check: () => document.querySelector('.chart-container') !== null,
		// 	importPath: () => import('../Chart'),
		// },
	},

	// Komponenty, které se NENačítají v admin.bundle (mají vlastní bundle)
	// Tyto komponenty se načítají jako samostatné bundle a pouze se inicializují v ComponentLoader
	externalBundles: {
		DataTable: {
			bundle: 'metronic/plugins/custom/datatables/datatables.bundle.js',
			initOnly: true, // Pouze inicializace, kód už je v bundle
		},
		Metronic: {
			bundle: 'metronic.bundle.js',
			initOnly: true, // Pouze inicializace, kód už je v bundle
		},
	},

	// Komponenty, které se mají načítat standardně (nejsou lazy ani external)
	standardLoad: {
		TempusDominus: true,
		ResponsiveButton: true,
		AreYouSureModal: true,
		BulkChecker: true,
		Select2: true,
		Select: true,
		FulltextSearcher: true,
		AplCodeGenerator: true,
		DatatableInitter: true,
		BulkDataTableChecker: true,
		BulkDataTableAction: true,
		TopMenu: true,
	},
};

